// import React from 'react'

// const MyAppraisal = () => {


//   return (
//     <div>MyAppraisal</div>
//   )
// }

// export default MyAppraisal

import { Box, Grid } from '@mui/material'
import React, { useEffect, useState } from 'react'
import CustomTable from '../../../Components/Table/CustomTable'
import { useDispatch, useSelector } from 'react-redux';
import { setHeaderName, setSubHeaderName } from '../../../ReduxStore/Slices/headerSlice';
import { Assessment } from '@mui/icons-material';
// import AppraisalPdfGenerator from './AppraisalPdfGenerator';
import { useNavigate } from 'react-router-dom';
import actions from '../../../ReduxStore/actions';
import { toast } from 'react-toastify';
import { adminUrl } from '../../../constants';
// import PDFGenerator from './AppraisalPdfGenerator';

const MyAppraisal = ({ dynamicLogo }) => {

    const tableData = [
        { appraisalFormId: "5555ASSEMBLY SUPERVISOR-34", employeeId: "5555", employeeName: "Vallarasu K", designation: "ASSEMBLY SUPERVISOR", emailId: "valla@gmail.com", doj: "01 -08 - 2023", department: "ASSEMBLY", reportingTo: "--", reviewer: "--", assessment: "2024-2025", period: "2024-2025", statusOfApproval: "Self Evaluation Completed", viewDetails: "View Details", reAppeal: "Request For Re Apply", downloadForm: "downloadForm", downloadAppraisalletter: "downloadAppraisalletter" },


    ]
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(setHeaderName("My Appraisal"));
        dispatch(setSubHeaderName(""));
    }, [dispatch]);

    const navigate = useNavigate()


    const handleEnterForm = (kra_kpi_id, employeeId, appraisalyearid) => {
        console.log(kra_kpi_id, employeeId, appraisalyearid, "idddekdkfkokrre")
        // navigate(`/employee/myappraisalform/${kra_kpi_id}${employeeId}${appraisalyearid}`)
        navigate('/employee/myappraisalform', {
            state: {
                kra_kpi_id,
                employeeId,
                appraisalyearid
            }
        });


    }
    const { getEmployeeKraKpiStatusList } = useSelector((state) => state?.getEmployeeKraKpiStatusList);

    const tableHeadData = ["S.No", "Employee ID", "Employee Name", "Designation", "Email ID", "DOJ", "Department", "Sub Department", "Reporting to", "Reviewer", "Assessment Period", "Status of Appraisal", "View Details", "Re Appeal", "Download Form", "Download Appraisal Letter"

    ];
    const { requestAppraisalReapply } = useSelector((state) => state?.requestAppraisalReapply);

    const employeeId = localStorage.getItem("employeeId")

    useEffect(() => {
        // const fetchData = async () => {

        const data1 = {
            data: {},
            method: "get",
            apiName: `getEmployeeKraKpiStatusList`
        };
        dispatch(actions.GETEMPLOYEEKRAKPISTATUSLIST(data1));

        // }
        // fetchData()

    }, [requestAppraisalReapply])


    const [rowTableData, setRowTableData] = useState([])
    console.log(rowTableData, "rowTableTAdatatattattat")




    useEffect(() => {

        const tempArr = [];
        getEmployeeKraKpiStatusList?.data?.map((data, index) => {
            return tempArr.push({
                // kra_kpi_question_id: data?.kra_kpi_question_id,
                kra_kpi_id: data?.kra_kpi_id,
                // id: data?.kra_kpi_id,
                // id: data?.kra_kpi_name,
                appraisalyearid: data?.appraisal_year_id,

                employeeId: data?.employee_id,
                employee_code: data?.employee_code,
                employee_name: data?.employee_name,
                designation_name: data?.designation_name,
                email: data?.email || "--",
                date_of_joining: data?.date_of_joining || "--",
                department_name: data?.department_name,
                sub_department_name: data?.sub_department_name,
                reportingTo: data?.reporting_manager_name || "--",
                reviewer: data?.reviewer_name || "--",
                appraisal_year: data?.appraisal_year || "--",
                appraisal_current_status: [data?.appraisal_current_status || "--", data?.reviewer_reject_comment || "--"],
                viewDetails: "View Details",
                reAppeal: [data?.appraisal_current_status, data?.appraisal_reapply_status],
                kra_kpi_answer_id: data?.kra_kpi_answer_id,


                downloadForm: "downloadForm",
                downloadAppraisalletter: data?.pms_score_show ? "downloadAppraisalletter" : "--",


                // downloadAppraisalletter: "downloadAppraisalletter"
                // reviewer: data?.reviewer || "--",





            });
        });
        setRowTableData(tempArr);




    }, [getEmployeeKraKpiStatusList])

    const handleRequestReapply = async (id) => {
        const data1 = {
            data: {},
            method: "put",
            apiName: `requestAppraisalReapply/${id}`
        };
        const responseData = await dispatch(actions.REQUESTAPPRAISALREAPPLY(data1));
        if (responseData?.payload?.message === "Reapply requested successfully.") {
            toast.success("Request for reapply sent successfully")
        } else {
            toast.error(responseData?.payload?.message)
        }


    }
    const authToken = localStorage.getItem("authToken");

    const handleDownloadAppraisalPdf = async (selectedYear,fileName) => {
        try {
            const response = await fetch(`${adminUrl}downloadPdfByName/year/${selectedYear}/filenName/${fileName}.pdf`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${authToken}`,
                }
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);

            const a = document.createElement('a');
            a.href = url;

            // Use the original file name (fallback to 'download.pdf' if not available)
            a.download = fileName || 'download.pdf';

            document.body.appendChild(a);
            a.click();
            a.remove();

            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Download failed:', error);
            // toast?.error()
        }
    };





    return (
        <div>
            <Box
                sx={{
                    background: "white",
                    p: 3,
                    mt: 6,
                    // maxWidth: "950px"
                }}
            >
                <Grid container spacing={2}>
                    <Grid item size={{ xs: 12 }} sx={{ width: "100px", flex: 1 }}>
                        <CustomTable
                            tableHeadData={tableHeadData}
                            tableData={rowTableData}
                            title="My Appraisal"
                            handleEnterForm={handleEnterForm}
                            // downloadForm={true}
                            // tableEdit={true}
                            // tableActions={true}
                            tableSearch={true}
                            handleRequestReapply={handleRequestReapply}
                            dynamicLogo={dynamicLogo}
                            handleDownloadAppraisalPdf={handleDownloadAppraisalPdf}
                        // tableActivate={true}

                        />
                        {/* <PDFGenerator /> */}

                    </Grid>
                </Grid>
                {/* <AppraisalPdfGenerator /> */}

            </Box></div>
    )
}

export default MyAppraisal